import React, { useContext, useState } from 'react';
import {
  CircularProgress,
  Container,
  Grid,
  Switch,
  Typography
} from '@mui/material';
import TopologyColumn from './topologyColumn';
import {
  getAmount,
  getHighestConnectionValue,
  JSONRecordData
} from '../Log/graph.util';
import { ProductIdContext } from '../../../contexts/ProductIdContextProvider';

interface TopologySodistoreHomeProps {
  values: JSONRecordData;
  connected: boolean;
  loading: boolean;
  batteryClusterNumber:number;
}

function TopologySodistoreHome(props: TopologySodistoreHomeProps) {
  if (props.values === null && props.connected == true) {
    return null;
  }
  const highestConnectionValue =
    props.values != null ? getHighestConnectionValue(props.values) : 0;

  const { product, setProduct } = useContext(ProductIdContext);

  const [showValues, setShowValues] = useState(false);

  const handleSwitch = () => () => {
    setShowValues(!showValues);
  };

  const isMobile = window.innerWidth <= 1490;

  const totalBatteryPower: number = Number(
    props.values && props.values.InverterRecord
      ? Array.from({ length: props.batteryClusterNumber }).reduce(
        (sum: number, _, index) => {
          const i = index + 1;

          const rawPower =
            props.values.InverterRecord[`Battery${i}Power`] as unknown;

          const power = Number(rawPower) || 0;

          return sum + power;
        },
        0
      )
      : 0
  );

  const pvPower =
    props.values?.InverterRecord?.PvPower ??
    ['PvPower1', 'PvPower2', 'PvPower3', 'PvPower4']
      .map((key) =>  props.values?.InverterRecord?.[key] ?? 0)
      .reduce((sum, val) => sum + val, 0);

  return (
    <Container maxWidth="xl" style={{ backgroundColor: 'white' }}>
      <Grid container>
        {!props.connected && !props.loading && (
          <Container
            maxWidth="xl"
            sx={{
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
              alignItems: 'center',
              height: '70vh'
            }}
          >
            <CircularProgress size={60} style={{ color: '#ffc04d' }} />
            <Typography
              variant="body2"
              style={{ color: 'black', fontWeight: 'bold' }}
              mt={2}
            >
              Unable to communicate with the installation
            </Typography>
            <Typography variant="body2" style={{ color: 'black' }}>
              Please wait or refresh the page
            </Typography>
          </Container>
        )}

        {props.connected && (
          <>
            <Grid
              item
              xs={12}
              md={12}
              style={{
                marginTop: '10px',
                height: '20px',
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'right',
                justifyContent: 'right'
              }}
            >
              {/*<div>*/}
              {/*  <Typography sx={{ marginTop: '5px', marginRight: '20px' }}>*/}
              {/*    Display Values*/}
              {/*  </Typography>*/}
              {/*  <Switch*/}
              {/*    edge="start"*/}
              {/*    color="secondary"*/}
              {/*    onChange={handleSwitch()}*/}
              {/*    sx={{*/}
              {/*      '& .MuiSwitch-thumb': {*/}
              {/*        backgroundColor: 'orange'*/}
              {/*      },*/}
              {/*      marginLeft: '20px'*/}
              {/*    }}*/}
              {/*  />*/}
              {/*</div>*/}
            </Grid>

            <Grid
              item
              xs={12}
              md={12}
              style={{
                height: isMobile ? '550px' : '600px',
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'center',
                justifyContent: 'center'
              }}
            >
              <TopologyColumn
                centerBox={{
                  title: 'Grid',
                  data: props.values?.InverterRecord
                    ? [
                      {
                        value: props.values.InverterRecord.GridPower,
                        unit: 'W'
                      }
                    ]
                    : undefined,
                  connected:
                    true
                }}
                centerConnection={{
                  orientation: 'horizontal',
                  data: props.values?.InverterRecord
                    ? {
                      value: props.values.InverterRecord.GridPower,
                      unit: 'W'
                    }
                    : undefined,
                  amount: props.values?.InverterRecord
                    ? getAmount(
                      highestConnectionValue,
                      props.values.InverterRecord.GridPower
                    )
                    : 0,
                  showValues: showValues
                }}
                isLast={false}
                isFirst={true}
              />
              {/*-------------------------------------------------------------------------------------------------------------------------------------------------------------*/}
              <TopologyColumn
                topBox={{
                  title: 'PV',
                  data: props.values?.InverterRecord
                    ? [
                      {
                        value: pvPower,
                        unit: 'W'
                      }
                    ]
                    : undefined,
                  connected: true
                }}
                topConnection={{
                  orientation: 'vertical',
                  position: 'top',
                  data: props.values?.InverterRecord
                    ? {
                      value: pvPower,
                      unit: 'W'
                    }
                    : undefined,
                  amount: props.values?.InverterRecord ? getAmount(highestConnectionValue, pvPower) : 0,
                  showValues: showValues
                }}
              centerBox={{
                  title: 'Inverter',
                  data: props.values?.InverterRecord
                    ? [
                      {
                        value: 0,
                        unit: 'W'
                      }
                    ]
                    : undefined,
                  connected: true
                }}
                centerConnection={{
                  orientation: 'horizontal',
                  data: props.values?.InverterRecord
                    ? {
                      value: totalBatteryPower,
                      unit: 'W'
                    }
                    : undefined,
                  amount: props.values?.InverterRecord
                    ? getAmount(highestConnectionValue, totalBatteryPower)
                    : 0,
                  showValues: showValues
                }}
                bottomBox={{
                  title: 'Loads',
                  data: props.values?.InverterRecord
                    ? [
                      {
                        value: props.values.InverterRecord.ConsumptionPower,
                        unit: 'W'
                      }
                    ]
                    : undefined,
                  connected:true
                }}
                bottomConnection={{
                  orientation: 'vertical',
                  position: 'bottom',
                  data: props.values?.InverterRecord
                    ? {
                      value: props.values.InverterRecord.ConsumptionPower,
                      unit: 'W'
                    }
                    : undefined,
                  amount: props.values?.InverterRecord
                    ? getAmount(
                      highestConnectionValue,
                      props.values.InverterRecord.ConsumptionPower
                    )
                    : 0,
                  showValues: showValues
                }}
                isLast={false}
                isFirst={false}
              />
              {/*-------------------------------------------------------------------------------------------------------------------------------------------------------------*/}
              {Array.from({ length: props.batteryClusterNumber }).map((_, index) => {
                const i = index + 1; // battery cluster index starting from 1

                return (
                  <TopologyColumn
                    key={i}
                    centerBox={{
                      title: `Battery C${i}`,
                      data: props.values.InverterRecord
                        ? [
                          {
                            value: props.values.InverterRecord[`Battery${i}Soc`],
                            unit: '%'
                          },
                          {
                            value: props.values.InverterRecord[`Battery${i}Power`],
                            unit: 'W'
                          }
                        ]
                        : undefined,
                      connected: true
                    }}
                    isFirst={false}
                    isLast={true}
                  />
                );
              })}
            </Grid>
          </>
        )}
      </Grid>
    </Container>
  );
}

export default TopologySodistoreHome;
